import { PapiDeviation } from '@wix/da-papi-types';

import { imageDeviations } from './images';
import { literatureDeviations } from './literature';
import { edgeCaseDeviations } from './edgeCases';
import { journals } from './journals';
import { filmDeviations } from './film';
import { flashDeviations } from './flash';
import { pdfDeviations } from './pdf';
import { pixelDeviations } from './pixel';
import { turtleDeviations } from './turtles';
import {
  statusDeviationsLegacy,
  statusDeviationsLong,
  statusDeviationsShort,
  statusDeviationsImageOnly,
  statuses,
} from './statuses';
import { pollDeviations } from './polls';
import { commissionDeviations } from './commissions';
import { dailyDeviations } from './daily';
import { tierDeviations } from './tiers';
import { originalDeviations } from './originals';

export const deviations: PapiDeviation[] = edgeCaseDeviations.concat(
  imageDeviations,
  pixelDeviations,
  literatureDeviations,
  journals,
  filmDeviations,
  flashDeviations,
  pdfDeviations,
  dailyDeviations,
  tierDeviations
);

export const deviationsByType = {
  image: imageDeviations,
  gif: imageDeviations.filter(d => d.isGif),
  pixel: pixelDeviations,
  literature: literatureDeviations,
  film: filmDeviations,
  flash: flashDeviations,
  journal: journals,
  pdf: pdfDeviations,
  statuses: [
    ...statuses,
    ...statusDeviationsLegacy,
    ...statusDeviationsLong,
    ...statusDeviationsShort,
    ...statusDeviationsImageOnly,
  ],
  polls: pollDeviations,
  commissions: commissionDeviations,

  daily: dailyDeviations,
  edgeCases: edgeCaseDeviations,
  turtles: turtleDeviations,
  tiers: tierDeviations,
  originals: originalDeviations,
};
